import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CalendarItem } from '../../../models/calendar.model';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CalendarService } from '../../../services/calendar/calendar.service';
import { CommonService } from '../../../services/utils/common.service';

@Component({
  selector: 'app-calendar-form',
  templateUrl: 'calendarForm.component.html',
  providers: [
    CommonService
  ],
  styles: ['label.required:after {top: 0}']
})

export class CalendarFormComponent implements OnChanges, OnInit {
  @Input() dialogBoxCalendar: CalendarItem;

  @Output() calendarAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() calendarUpdated: EventEmitter<any> = new EventEmitter<any>();

  addEditForm: FormGroup;
  fields: any;
  invalidSubmit: boolean;

  constructor (
    private fb: FormBuilder,
    public srvCalTranslate: CalendarTranslateService,
    private srvCalendar: CalendarService
  ) { }

  ngOnInit(): void {

    this.srvCalendar.getFields().subscribe(res => {
      this.fields = res;
    });

   }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxCalendar.code),
        'description': new FormControl(this.dialogBoxCalendar.description),
        'time_range': new FormControl(this.dialogBoxCalendar.time_range),
        'monday': new FormControl('', []),
        'tuesday': new FormControl('', []),
        'wednesday': new FormControl('', []),
        'thursday': new FormControl('', []),
        'friday': new FormControl('', []),
        'saturday': new FormControl('', []),
        'sunday': new FormControl('', []),
        'flg_extra_open': new FormControl('', [])
    });

    console.log('oform', this.dialogBoxCalendar, this.dialogBoxCalendar.id);

    if (this.dialogBoxCalendar.id != null) {
      this.addEditForm.controls['monday'].setValue(this.dialogBoxCalendar.monday === '1');
      this.addEditForm.controls['tuesday'].setValue(this.dialogBoxCalendar.tuesday === '1');
      this.addEditForm.controls['wednesday'].setValue(this.dialogBoxCalendar.wednesday === '1');
      this.addEditForm.controls['thursday'].setValue(this.dialogBoxCalendar.thursday === '1');
      this.addEditForm.controls['friday'].setValue(this.dialogBoxCalendar.friday === '1');
      this.addEditForm.controls['saturday'].setValue(this.dialogBoxCalendar.saturday === '1');
      this.addEditForm.controls['sunday'].setValue(this.dialogBoxCalendar.sunday === '1');
      this.addEditForm.controls['flg_extra_open'].setValue(this.dialogBoxCalendar.flg_extra_open === '1');
    } else {
      this.addEditForm.controls['monday'].setValue(false);
      this.addEditForm.controls['tuesday'].setValue(false);
      this.addEditForm.controls['wednesday'].setValue(false);
      this.addEditForm.controls['thursday'].setValue(false);
      this.addEditForm.controls['friday'].setValue(false);
      this.addEditForm.controls['saturday'].setValue(false);
      this.addEditForm.controls['sunday'].setValue(false);
      this.addEditForm.controls['flg_extra_open'].setValue(false);
    }
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData: CalendarItem = Object.assign({}, this.dialogBoxCalendar, this.addEditForm.value);

    newData.monday = newData.monday ? '1' : '0';
    newData.tuesday = newData.tuesday ? '1' : '0';
    newData.wednesday = newData.wednesday ? '1' : '0';
    newData.thursday = newData.thursday ? '1' : '0';
    newData.friday = newData.friday ? '1' : '0';
    newData.saturday = newData.saturday ? '1' : '0';
    newData.sunday = newData.sunday ? '1' : '0';
    newData.flg_extra_open = newData.flg_extra_open ? '1' : '0';

    if (newData.id == null) {
      this.calendarAdded.emit(newData);
    } else {
      this.calendarUpdated.emit(newData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar/calendarForm.component.ts